import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/base.css'
import { uploadImg, imageCompression } from '@/utils/file'
// import Vconsole from 'vconsole'
import loadGoogleMaps from '@/utils/google-maps-loader'
import i18n from '@/i18n'

import 'amfe-flexible'

import NavHeaderBar from '@/components/NavHeaderBar.vue'
import checkPer from '@/utils/permission'
import {
  NavBar, Form, Cell, List, ActionSheet,
  Field, Button, Icon, PullRefresh,
  Tabbar, TabbarItem, Tabs, Tab, Dialog,
  Popup, Row, Col, Badge, Search, Divider,
  Tag, CellGroup, Image, DatetimePicker, Stepper, Uploader, RadioGroup, Radio, Checkbox, CheckboxGroup, SwipeCell, Empty, Picker, CountDown, Calendar, Locale,
  Circle, Pagination, Sticky, Collapse, CollapseItem, DropdownMenu, DropdownItem, Cascader, Step, Steps, Popover, IndexBar, IndexAnchor, Switch
} from 'vant'

// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US'

// 刚才少些了这么一行代码，需要把 permission.js 文件 导入 main.js，让其生效
import './permission'

loadGoogleMaps()

Vue.component(NavHeaderBar.name, NavHeaderBar)

Vue.use(checkPer)

Locale.use('en-US', enUS)

Vue.prototype.$uploadImg = uploadImg
Vue.prototype.$imageCompression = imageCompression

// 把公共函数 加入 到 vue的原型上，
// 原理就是：每个vue组件都是继承自Vue的实例，可以直接访问vue原型上的一切属性和方法

Vue.use(DatetimePicker)
Vue.use(Image)
Vue.use(Tag)
Vue.use(CellGroup)
Vue.use(Divider)
Vue.use(Search)
Vue.use(Badge)
Vue.use(Row)
Vue.use(Col)
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(ActionSheet)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Cell)
Vue.use(NavBar)
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Stepper)
Vue.use(Uploader)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(SwipeCell)
Vue.use(Empty)
Vue.use(Picker)
Vue.use(CountDown)
Vue.use(Calendar)
Vue.use(Circle)
Vue.use(Pagination)
Vue.use(Sticky)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Cascader)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Popover)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(Switch)

Vue.config.productionTip = false

// if (process.env.NODE_ENV !== 'production') { // 测试和开发打开，生产不能打开
//   let vConsole = new Vconsole()
//   Vue.use(vConsole)
// }

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
